import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { useIsMobile } from "../../utils/responsive";

import about1 from "../../assets/Images/About/KGM-161.jpg";
import about2 from "../../assets/Images/About/_TAR6266-1.jpg";

export default function ImageBanner1() {
  const [hoveredImage, setHoveredImage] = useState(null);
  const isMobile = useIsMobile();

  return (
    <Container fluid className="p-0">
      {/* Main Content Row */}
      <div
        className="d-flex justify-content-center"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}

        {/* Image Column */}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: isMobile ? "none" : "1px solid black",
            // borderLeft: "1px solid black",
            padding: "0",
            overflow: "hidden",
          }}
        >
          <div
            className="image-container"
            style={{
              height: "100%",
              minHeight: isMobile ? "400px" : "600px",
              display: "flex",
              flexDirection: "row",
              gap: "0",
              transition: "all 0.5s ease",
            }}
            onMouseEnter={() => setHoveredImage(1)}
            onMouseLeave={() => setHoveredImage(null)}
          >
            <img
              src={about1}
              alt="Profile 1"
              className="image-cover-full-responsive"
              style={{
                transition: "all 0.5s ease",
                transform: hoveredImage === 1 ? "scale(1.05)" : "scale(1)",
                filter:
                  hoveredImage === 1 ? "brightness(1.05)" : "brightness(1)",
              }}
            />
          </div>
        </div>

        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
            padding: "0",
            overflow: "hidden",
          }}
        >
          <div
            className="image-container"
            style={{
              height: "100%",
              minHeight: isMobile ? "400px" : "600px",
              display: "flex",
              flexDirection: "row",
              gap: "0",
              transition: "all 0.5s ease",
            }}
            onMouseEnter={() => setHoveredImage(2)}
            onMouseLeave={() => setHoveredImage(null)}
          >
            <img
              src={about2}
              alt="Profile 1"
              className="image-cover-full-responsive"
              style={{
                transition: "all 0.5s ease",
                transform: hoveredImage === 2 ? "scale(1.05)" : "scale(1)",
                filter:
                  hoveredImage === 2 ? "brightness(1.05)" : "brightness(1)",
              }}
            />
          </div>
        </div>

        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
